// export this package's api
import Rate from './src/'
export default Rate



// WEBPACK FOOTER //
// ./components/vc-rate/index.js